
const UPDATE_TRANSACTION_INFO = function (state, assetsBidInfos) {
  state.assetsBidInfos = assetsBidInfos;
};

export default {
  UPDATE_TRANSACTION_INFO
};
